import { DashboardSportRef, SportRef as ApiSportRef } from "@/api/__generated__/schemas";
import { SportFragment } from "@/graphql";
import { Sport, SportRef } from "@/types/sport.types";

export const mapToSport = (fragment: SportFragment): Sport => ({
  id: fragment.id,
  title: fragment.title!,
  icon: fragment.icon ?? null,
});

export const mapToSportRef = (input: ApiSportRef | DashboardSportRef): SportRef => ({
  id: input.id,
  title: input.title ?? null,
  icon: input.icon ?? null,
});
